import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GAMES } from '../../data/games';
import './Games.css';

const ArrowIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14" />
    <path d="M13 6l6 6-6 6" />
  </svg>
);

export const Games: React.FC = () => {
  useEffect(() => { document.title = 'Games | Practical Media'; }, []);

  return (
    <div className="games-page">
      <header className="container games-head">
        <p className="label accent">The roster</p>
        <h1 className="games-title">Games we publish</h1>
        <p className="games-intro">
          Indie games we publish. Each one keeps 100% of its IP, on a performance-based split.
        </p>
      </header>

      <section className="container games-section">
        <div className="games-grid">
          {GAMES.map((g) => {
            const primary = g.links?.find((l) => l.primary);
            const title = g.subtitle ? `${g.title}: ${g.subtitle}` : g.title;
            return (
              <article key={g.slug} className="game-tile" style={{ ['--ga' as string]: g.accent } as React.CSSProperties}>
                <Link to={`/games/${g.slug}`} className="game-tile-media" aria-label={`${title} details`}>
                  <img src={g.coverImage || g.heroImage} alt={`${g.title} key art`} loading="lazy" />
                </Link>
                <div className="game-tile-body">
                  <div className="game-tile-top">
                    <h2 className="game-tile-title">
                      <Link to={`/games/${g.slug}`}>{g.title}{g.subtitle ? <span> · {g.subtitle}</span> : null}</Link>
                    </h2>
                    <span className="game-tile-status">{g.status}</span>
                  </div>
                  <p className="game-tile-studio">{g.studio}</p>
                  <p className="game-tile-tag">{g.tagline}</p>
                  <div className="game-tile-links">
                    {primary ? (
                      <a className="game-play" href={primary.href} target="_blank" rel="noopener noreferrer">
                        {primary.label} <ArrowIcon />
                      </a>
                    ) : null}
                    <Link className="game-play alt" to={`/games/${g.slug}`}>Details</Link>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <section className="container games-section">
        <div className="games-cta">
          <h2>Have a game? Pitch it.</h2>
          <p>Tell us what you are building. We read every submission, and the first conversation is always free.</p>
          <Link to="/contact" className="primary-btn">Pitch your game</Link>
        </div>
      </section>
    </div>
  );
};
